// extracted by mini-css-extract-plugin
export var inter = "Inter,sans-serif";
export var lg = "992";
export var md = "768";
export var primary = "#f70";
export var roboto = "Roboto,sans-serif";
export var sm = "576";
export var xl = "1440";
export var xs = "425";